import './App.css';
import { Header } from './Components/Header';
import { HeroSection } from './Components/HeroSection';
import { OpportunitySection } from './Components/OpportunitySection';
import { GlobalToWalletsSection } from './Components/GlobalToWalletsSection';
import { HowItWorksSection } from './Components/HowItWorksSection';
import { MonetizedPlatformsSection } from './Components/MonetizedPlatformsSection';
import { ComplianceSection } from './Components/ComplianceSection';
import { FinalCtaSection } from './Components/FinalCtaSection';
import { Footer } from './Components/Footer';
import bindflowLogo from "./Assets/bindflow_logo.png";

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <OpportunitySection />
      <GlobalToWalletsSection />
      <HowItWorksSection />
      <MonetizedPlatformsSection />
      <ComplianceSection />
      <FinalCtaSection />
      <Footer />
      <div className='created'>
        <p>Created by</p>
        <img src={bindflowLogo} alt="" />
      </div>
    </div>
  );
}

export default App;
